import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import noop from 'lodash/noop';
import moment from 'moment';
import Pagination from '../../../shared/pagination';

const Table = ({ table, intl, sortByColumn, showMoreRows, pagination, gotoPage, editPoll, deletePoll, can }) => (
	<div className="table-container polls-table">
		<table className="simple-table">
			<thead className="simple-table__head font-roboto-medium">
				<tr>
					{table.headers.map((header, i) => (
						<th
							key={i}
							className={cn({
								'sort-header': header.direction,
								active: table.sortedColumn.index === header.index,
								[header.className]: header.className,
								[table.sortedColumn.direction]:
									table.sortedColumn.index === header.index && table.sortedColumn.direction
							})}
							onClick={() => (header.direction ? sortByColumn(header.index) : noop)}
						>
							{intl(header.title)}
						</th>
					))}
				</tr>
			</thead>

			<tbody className="simple-table__body">
				{table.rows.map((row, i) => (
					<tr key={i}>
						<td className="id">
							<span>{row.id}</span>
						</td>
						<td className="created-at">
							<span>{moment(row.created_at).format('DD.MM.YYYY')}</span>
						</td>
						<td className="url">
							<span>
								<a href={row.form_url} target="_blank">
									{row.form_url}
								</a>
							</span>
						</td>
						<td className="status">
							<span>{row.status}</span>
						</td>
						<td className="language">
							<span>{row.language}</span>
						</td>
						<td className="actions">
							{can('edit') && (
								<a
									href="#"
									onClick={e => {
										e.preventDefault();
										editPoll(row);
									}}
									className="action_edit"
								/>
							)}
							{can('delete') && (
								<a
									href="#"
									onClick={e => {
										e.preventDefault();
										confirm(intl('Delete poll?')) && deletePoll(row.id);
									}}
									className="action_delete"
								/>
							)}
						</td>
					</tr>
				))}
			</tbody>
		</table>
		<Pagination pagination={pagination} gotoPage={gotoPage} />
	</div>
);

Table.propTypes = {
	table: PropTypes.object,
	pagination: PropTypes.object,
	gotoPage: PropTypes.func,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	showMoreRows: PropTypes.func,
	editPoll: PropTypes.func,
	deletePoll: PropTypes.func,
	can: PropTypes.func
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/polls/components/table/main.js